import { EnvironmentSports } from '@bcf-shared-settings/settings/types';

export const environmentBase: Pick<EnvironmentSports, 'apiLanguageMap'> = {
  apiLanguageMap: {
    en: 'en-GB',
    lv: 'lv-LV',
    ru: 'ru-RU'
  }
};
